import React from "react";
import { Box, Pagination, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const PaginationColors = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Pagination Colors
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          Pagination Provide three colors "primary", "secondary", "standard".
          However, you can use other colors like - "error", "info", "warning",
          "success".
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          title={"Colored Pagination. 'standard' | 'primary' | 'secondary'."}
          value={
            "                <Pagination count={10} />\n" +
            '                    <Pagination count={10} color={"primary"} />\n' +
            '                    <Pagination count={10} color={"secondary"}  />'
          }
        >
          <Stack direction={"column"} spacing={2}>
            <Pagination count={10} />
            <Pagination count={10} color={"primary"} />
            <Pagination count={10} color={"secondary"} />
          </Stack>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default PaginationColors;
